import { useNavigate } from 'react-router';
import { Box } from '@/components/Box/Box';
import { Typography } from '@/components/Typography/Typography';
import { ButtonNew } from '@/components-new/ButtonNew/ButtonNew';
import { formatDate, FULL_DATE_TIME_FORMAT } from '@/helpers/dateHelpers/dateHelpers';
import { getAuditLogPath } from '@/bundle/_OrgAdmin/pages/AuditLogPage/path/path';
import { RecentActivityRowType } from '@/types/dashboardTypes';
import { LinkButton, Mono } from '../styles';
import { TableNew } from '@/components-new/TableNew/TableNew';
import { TableBodyNew, TableCellNew, TableRowNew } from '@/components-new/TableNew/styles';
import { TableHeadNew } from '@/components-new/TableNew/TableHeadNew';
import { TableHeadCellNew } from '@/components-new/TableNew/TableHeadCellNew';

type RecentActivityType = {
  rows: RecentActivityRowType[];
  isLoading: boolean;
  onNextStep: (row: RecentActivityRowType) => void;
};

export const RecentActivity = ({ rows = [], onNextStep, isLoading }: RecentActivityType) => {
  const navigate = useNavigate();

  const openInAuditLog = (row: RecentActivityRowType) => {
    navigate(`${getAuditLogPath()}?q=${encodeURIComponent(row.object_label)}`);
  };

  return (
    <TableNew
      header={
        <Box display='flex' justifyContent='space-between'>
          <Typography fontWeight='semibold'>Recent activity</Typography>
          <Typography variant='caption'>
            Click a row to open it in the audit log. Completed actions offer a next step.
          </Typography>
        </Box>
      }
      isLoading={isLoading}
      itemsCount={rows.length}
      noItems='Nothing yet. Activity appears here as soon as you share, verify or receive.'
      footer={<LinkButton onClick={() => navigate(getAuditLogPath())}>Open audit log</LinkButton>}
    >
      <>
        <TableHeadNew>
          <TableHeadCellNew>WHEN</TableHeadCellNew>
          <TableHeadCellNew>EVENT</TableHeadCellNew>
          <TableHeadCellNew>ACTOR</TableHeadCellNew>
          <TableHeadCellNew>OBJECT</TableHeadCellNew>
          <TableHeadCellNew>ACTION</TableHeadCellNew>
        </TableHeadNew>
      </>
      <TableBodyNew>
        {rows.map((row) => (
          <TableRowNew key={row.id}>
            <TableCellNew>{formatDate(row.date_created, FULL_DATE_TIME_FORMAT)}</TableCellNew>
            <TableCellNew onClick={() => openInAuditLog(row)}>
              <LinkButton>
                <Mono>{row.event}</Mono>
              </LinkButton>
            </TableCellNew>
            <TableCellNew>{row.actor_label}</TableCellNew>
            <TableCellNew>{row.object_label}</TableCellNew>
            <TableCellNew>
              {' '}
              {row.offers_next_step && (
                <ButtonNew size='medium' variant='secondary' onClick={() => onNextStep(row)}>
                  Next step
                </ButtonNew>
              )}
            </TableCellNew>
          </TableRowNew>
        ))}
      </TableBodyNew>
    </TableNew>
  );
};
